export default __webpack_public_path__ + "static/media/Rodolfo6.b6f7e9e9.png";